// extracted by mini-css-extract-plugin
module.exports = {"root":"AsyncDropdown_root__ZUFle"};